export class SkuPriceModel {
    endDate: string;
    startDate: string;
    value: number; // Sku Price
    normalisedFactoredUpliftedPrice: number; // FactoredPrice
}
